import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';

class QuickShopMediaSlider extends HTMLElement {
  #viewport = this.querySelector('.embla__viewport');
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;
  #draggable = true;

  connectedCallback() {
    this.#initCarousel();
  }

  disconnectedCallback() {
    this.#viewport?.removeEventListener('mousedown', this.#onGesture);
    this.#viewport?.removeEventListener('touchstart', this.#onGesture);
    this.#embla?.off('reinit', this.#updateDraggable);
    this.#embla?.destroy();
  }

  /**
   * Initialize the media thumbnail strip.
   * Slides-per-view is driven by the slide width classes in the Liquid markup.
   */
  #initCarousel() {
    if (!this.#viewport) return;

    this.#viewport.addEventListener('mousedown', this.#onGesture);
    this.#viewport.addEventListener('touchstart', this.#onGesture, { passive: true });

    this.#embla = EmblaCarousel(this.#viewport, { align: 'start', skipSnaps: true });
    this.#embla.on('reinit', this.#updateDraggable);
    this.#updateDraggable();
  }

  /**
   * The quick-shop renders inside the product card, so a drag would otherwise
   * bubble up and move the parent carousel. Always contain it.
   * @param {Event} event
   */
  #onGesture = (event) => {
    event.stopPropagation();
  };

  /**
   * Disable dragging when every thumbnail already fits, so the strip doesn't
   * slide with too few slides. Re-checked on each reInit (e.g. resize, or when
   * the dialog opens and the strip is first measured).
   */
  #updateDraggable = () => {
    const canScroll = this.#embla.canGoToPrev() || this.#embla.canGoToNext();
    if (canScroll === this.#draggable) return;

    this.#draggable = canScroll;
    this.#embla.reInit({ draggable: canScroll });
  };
}

customElements.define('quick-shop-media-slider', QuickShopMediaSlider);
